export default __webpack_public_path__ + "static/media/IMG27.67cab353.jpg";